module.exports = __webpack_public_path__ + "img/x_thumb.435dbb7f.gif";